import { Box, Button, Center, Text, useDisclosure } from "@chakra-ui/react";
import { BgClearSVG, ClearSVG, CloseNewSVG } from "assets";
import { AbstractModal, IconMenuItem } from "components";
import configs from "config";
import ls from "utils/secureStorage";

// Log Out
const ClearCurrentSession = () => {
  const { isOpen, onClose, onOpen } = useDisclosure();
  const email = ls.get("email");

  const handleLogout = () => {
    const URL = ls.get(configs.PERSIST_URL);
    ls.remove(configs.AUTH_TOKEN_KEY);
    ls.remove("email");
    ls.remove("quote_id");
    ls.remove("fiatAccountId");
    onClose();
    window.location.replace(`/${URL}`);
  };

  return (
    <>
      <IconMenuItem svg={<ClearSVG />} title="Log Out" onClick={onOpen} />

      <AbstractModal
        isOpen={isOpen}
        onClose={onClose}
        isCentered={false}
        _content={{
          maxW: "334px",
          borderRadius: "20px",
          p: "78px 14px 45px",
        }}
      >
        <Box
          pos="absolute"
          top={{ base: "3%", md: "3%" }}
          right={{ base: "6%", md: "5%" }}
          onClick={onClose}
          cursor="pointer"
          _hover={{
            zoom: "1.05",
            transition: "all .5s ease-in",
          }}
        >
          <CloseNewSVG />
        </Box>

        <Center flexDir="column">
          <BgClearSVG />

          <Text margin={{ base: "12px 0 29px" }} fontWeight="700" fontFamily="var(--bitmama-fonts-heading)">
            {/* Clear session */}
            Log Out
          </Text>

          <Text maxWidth="186px" mx="auto" textAlign="center">
            Are you sure you want to log out of this session?
          </Text>

          <Text fontSize="14px" fontWeight="600">
            {email}
          </Text>

          <Button margin={{ base: "48px 0 30px" }} minW="100%" onClick={handleLogout}>
            Yes, &nbsp;Log Out
          </Button>

          <Text cursor="pointer" textDecor="underline" fontWeight="500" onClick={onClose} color="#0D4740">
            Cancel
          </Text>
        </Center>
      </AbstractModal>
    </>
  );
};

export default ClearCurrentSession;
